<div class="casinolobbycontainer">
  <div class="box" *ngFor="let item of gameTypes" (click)="openGame(item)" [ngStyle]="{ 'background-image': 'url(/images/casino/' + item.thumb + ')' }">
    <span>{{ item.text }}</span>
  </div>
</div>
